var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-info"},[_c('div',{staticClass:"close"},[_c('span',{on:{"click":function($event){return _vm.close()}}},[_vm._v("x")])]),_c('div',{staticClass:"info"},[_c('span',[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }